import React from 'react';
import moment from 'moment';
// Deprecation warning for the min/max functions.
// Working as intended but swapped since a earlier release
moment.suppressDeprecationWarnings = true;

import { FormField } from 'ui/form/form-field';
import { DateTimeFieldProps } from 'ui/form/fields';
import TextField from 'ui/form/text-field';

import { REQUIRED } from 'ui/form/constants';
import { isValue } from 'ui/form/utils';

interface DateTimeFieldState {
  displayValue: '';
}

function timeToDate(time: string): string {
  return `2018-01-01 ${time}`;
}

const FORMAT = {
  'datetime-local': 'YYYY-MM-DDTHH:mm',
  time: 'HH:mm',
  date: 'YYYY-MM-DD'
};

export default class DateTimeField extends FormField<DateTimeFieldProps, DateTimeFieldState> {
  static getErrors(props: DateTimeFieldProps, formData) {
    const value = isValue(props.value) ? props.value : (formData || {})[props.name];
    if (!value === null || value === undefined && props.required) return REQUIRED;
    
    return TextField.getErrors(props, formData);
  }
  
  state = { error: false };
  
  get type() {
    const { noTime, noDate } = this.props;
    if (noTime) return 'date';
    else if (noDate) return 'time';
    else return 'datetime-local';
  }

  get formattedValue() {
    const { value, noDate } = this.props;
    return value && moment(noDate ? timeToDate(value) : value).format(FORMAT[this.type]);
  }

  validate(onlyTouched: boolean) {
    const errors = DateTimeField.getErrors(this.props);
    this.setState({ errors });
    
    return !errors;
  }
  
  handleBlur = () => {
    setTimeout(() => {
      if (this.textField.input.value) this.textField.input.value = this.formattedValue;
    });
  };

  handleChange = date => {
    const { isoFormat, onChange, min, max } = this.props;
    if (!date) return;
    if (this.state.errors) this.setState({errors: false});
    
    if (this.type === 'time') {
      if (min && date < min) {
        this.setState({ errors: 'Time must be after ' + min});
        date = min;
      }
      
      if (max && date > max) {
        this.setState({ errors: 'Time must be before ' + max});
        date = max;
      }

      onChange(moment(timeToDate(date)).format(FORMAT[this.type]));
    } else {
      // If only date then make it central time before moment initialized
      if (this.props.noTime) date += 'T00:00Z';
      let momentDate = moment(date);
      
      if (min && momentDate.isBefore(min)) {
        this.setState({errors: 'Select a date after ' + min});
        momentDate = momentDate.min(min);
      }
      
      if (max && momentDate.isAfter(max)) {
        this.setState({errors: 'Select a date before ' + max});
        momentDate = momentDate.max(max);
      }
      
      onChange(isoFormat ? momentDate.toISOString() : momentDate.unix() * 1000);
    }
  };
  
  render() {
    const { errors } = this.state;
    const { ...rest } = this.props;

    return (
      <TextField
        {...rest}
        error={errors}
        ref={ref => (this.textField = ref)}
        type={this.type}
        value={this.formattedValue}
        label={this.props.label}
        onChange={this.handleChange}
        onBlur={this.handleBlur}
      />
    );
  }
}
